import type { IconSvgObject } from './types';

const WhatsappBusinessIcon: IconSvgObject = [
  ["path", { d: "M11.998 22.002C17.522 22.002 22 17.5239 22 12C22 6.47607 17.522 1.99805 11.998 1.99805C6.47411 1.99805 1.99609 6.47607 1.99609 12C1.99609 13.8889 2.43006 15.4979 3.34008 17.005L1.99787 22L6.96849 20.666C8.48148 21.5862 10.0978 22.002 11.998 22.002Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 12H12.7678M9 12V7.5H12.7678C14.0006 7.5 15 8.60383 15 9.7084C15 10.813 14.0006 12 12.7678 12M9 12V16.5H12.7678C14.0006 16.5 15 15.4376 15 14.333C15 13.2284 14.0006 12 12.7678 12", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default WhatsappBusinessIcon;
